import { Banner } from "features/banner/types";
import { APP_PATH } from "./path";

export enum POSITION {
	HOMEPAGE_TOP = "homepage_top",
	HOMEPAGE_CENTER = "homepage_center",
	HOMEPAGE_SERVICE = "homepage_service",
	LIST_CAR_FOR_SALE = "list_car_for_sale",
	LIST_CAR_FOR_RENT = "list_car_for_rent",
	LIST_CAR_PART = "list_car_part",
	CAR_FOR_SALE_DETAIL = "car_for_sale_detail",
	CAR_FOR_RENT_DETAIL = "car_for_rent_detail",
	CAR_PART_DETAIL = "car_part_detail",
	CAR_STORE_DETAIL = "car_store_detail",
	LIST_NEW_EVENT = "list_new_event",
	LIST_SERVICE = "list_service",
	LIST_COMMUNITY = "list_community",
	COMMUNITY_DETAIL = "community_detail",
	LIST_CAR_FOR_SALE_TOP = "list_car_for_sale_top",
	LIST_CAR_FOR_RENT_TOP = "list_car_for_rent_top",
	LIST_CAR_PART_TOP = "list_car_part_top",
	LIST_CAR_CARE_TOP = "list_car_wash_top",
	LIST_CAR_CARE = "list_car_wash",
	CAR_CARE_DETAIL = "car_wash_detail",
	CAR_CARE_STORE_DETAIL = "car_wash_store_detail",
	CAR_REGISTRATION = "car_registration_screen",
	SELL_YOUR_CAR = "sell_your_car",
	MENU_SERVICES = "menu_services",
	IMPORT_SUPERCAR = "import_car_top",
	IMPORT_SUPERCAR_DETAIL = "import_car_detail",
	VOUCHER_TOP = "voucher_top",
	SUPPORT_SERVICES_TOP = "support_services_top",
	FINANCIAL_SERVICE_TOP = "financial_service_top",
	CAR_LOAN_TOP = "car_loan_top",
}
export const BANNER_POSITION: {
	[key: string]: {
		key: string;
		label: string;
	};
} = {
	HOMEPAGE_TOP: {
		key: POSITION.HOMEPAGE_TOP,
		label: "Homepage top",
	},
	HOMEPAGE_CENTER: {
		key: POSITION.HOMEPAGE_CENTER,
		label: "Homepage center",
	},
	HOMEPAGE_SERVICE: {
		key: POSITION.HOMEPAGE_SERVICE,
		label: "Homepage service",
	},
	LIST_CAR_FOR_SALE: {
		key: POSITION.LIST_CAR_FOR_SALE,
		label: "List cars for sale",
	},
	LIST_CAR_FOR_RENT: {
		key: POSITION.LIST_CAR_FOR_RENT,
		label: "List cars for rent",
	},
	LIST_CAR_PART: {
		key: POSITION.LIST_CAR_PART,
		label: "List car accessories",
	},
	CAR_FOR_SALE_DETAIL: {
		key: POSITION.CAR_FOR_SALE_DETAIL,
		label: "Car for sale detail",
	},
	CAR_FOR_RENT_DETAIL: {
		key: POSITION.CAR_FOR_RENT_DETAIL,
		label: "Car for rent detail",
	},
	CAR_PART_DETAIL: {
		key: POSITION.CAR_PART_DETAIL,
		label: "Car part detail",
	},
	CAR_STORE_DETAIL: {
		key: POSITION.CAR_STORE_DETAIL,
		label: "Car store detail",
	},
	LIST_NEW_EVENT: {
		key: POSITION.LIST_NEW_EVENT,
		label: "List news and events",
	},
	LIST_SERVICE: {
		key: POSITION.LIST_SERVICE,
		label: "List service",
	},
	LIST_COMMUNITY: {
		key: POSITION.LIST_COMMUNITY,
		label: "List Community",
	},
	COMMUNITY_DETAIL: {
		key: POSITION.COMMUNITY_DETAIL,
		label: "Community detail",
	},
	LIST_CAR_FOR_SALE_TOP: {
		key: POSITION.LIST_CAR_FOR_SALE_TOP,
		label: "List cars for sale top",
	},
	LIST_CAR_FOR_RENT_TOP: {
		key: POSITION.LIST_CAR_FOR_RENT_TOP,
		label: "List cars for rent top",
	},
	LIST_CAR_PART_TOP: {
		key: POSITION.LIST_CAR_PART_TOP,
		label: "List cars accessories top",
	},
	LIST_CAR_CARE_TOP: {
		key: POSITION.LIST_CAR_CARE_TOP,
		label: "List car care top",
	},
	LIST_CAR_CARE: {
		key: POSITION.LIST_CAR_CARE,
		label: "List car care",
	},
	CAR_CARE_DETAIL: {
		key: POSITION.CAR_CARE_DETAIL,
		label: "Car care detail",
	},
	CAR_CARE_STORE_DETAIL: {
		key: POSITION.CAR_CARE_STORE_DETAIL,
		label: "Car care store detail",
	},
	CAR_REGISTRATION: {
		key: POSITION.CAR_REGISTRATION,
		label: "Car registration",
	},
	SELL_YOUR_CAR: {
		key: POSITION.SELL_YOUR_CAR,
		label: "Sell your car",
	},
	MENU_SERVICES: {
		key: POSITION.MENU_SERVICES,
		label: "Menu services",
	},
	IMPORT_SUPERCAR: {
		key: POSITION.IMPORT_SUPERCAR,
		label: "Import supercar",
	},
	IMPORT_SUPERCAR_DETAIL: {
		key: POSITION.IMPORT_SUPERCAR_DETAIL,
		label: "Import supercar detail",
	},
	VOUCHER_TOP: {
		key: POSITION.VOUCHER_TOP,
		label: "Voucher top",
	},
	SUPPORT_SERVICES_TOP: {
		key: POSITION.SUPPORT_SERVICES_TOP,
		label: "Support Services",
	},
	FINANCIAL_SERVICE_TOP: {
		key: POSITION.FINANCIAL_SERVICE_TOP,
		label: "Financial Service Top",
	},
	CAR_LOAN_TOP: {
		key: POSITION.CAR_LOAN_TOP,
		label: "Car Loan Top",
	},
};


export const BANNER_TYPE = {
	MOBILE_HORIZONTAL: "mobile_horizontal",
	MOBILE_VERTICAL: "mobile_vertical",
	WEB_HORIZONTAL: "web_horizontal",
	WEB_VERTICAL: "web_vertical",
};

export const BANNER_TYPE_CONFIG = {
	[BANNER_TYPE.MOBILE_HORIZONTAL]: {
		createLink: (key: string) =>
			`${APP_PATH.appHorizontalBannerCreate}?position=${key}&type=${BANNER_TYPE.MOBILE_HORIZONTAL}`,
		detailLink: (record: Banner, language?: string) =>
			`${APP_PATH.appHorizontalBanners}/${
				record.groupCode
			}?language=${language}&position=${
				record.position || BANNER_POSITION.HOMEPAGE_TOP.key
			}&type=${BANNER_TYPE.MOBILE_HORIZONTAL}`,
		path: APP_PATH.appHorizontalBanners,
		label: "Horizontal banners",
	},
	[BANNER_TYPE.WEB_HORIZONTAL]: {
		createLink: (key: string) =>
			`${APP_PATH.webappHorizontalBannerCreate}?position=${key}&type=${BANNER_TYPE.WEB_HORIZONTAL}`,
		detailLink: (record: Banner, language?: string) =>
			`${APP_PATH.webappHorizontalBanners}/${
				record.groupCode
			}?language=${language}&position=${
				record.position || BANNER_POSITION.HOMEPAGE_TOP.key
			}&type=${BANNER_TYPE.WEB_HORIZONTAL}`,
		path: APP_PATH.webappHorizontalBanners,
		label: "Horizontal banners",
	},
	[BANNER_TYPE.WEB_VERTICAL]: {
		createLink: (key: string) =>
			`${APP_PATH.webappVerticalBannerCreate}?position=${key}&type=${BANNER_TYPE.WEB_VERTICAL}`,
		detailLink: (record: Banner, language?: string) =>
			`${APP_PATH.webappVerticalBanners}/${
				record.groupCode
			}?language=${language}&position=${
				record.position || BANNER_POSITION.HOMEPAGE_TOP.key
			}&type=${BANNER_TYPE.WEB_VERTICAL}`,
		path: APP_PATH.webappVerticalBanners,
		label: "Vertical banners",
	},
};
export const BANNER_POSITIONS_APP = [
	BANNER_POSITION.HOMEPAGE_TOP,
	BANNER_POSITION.HOMEPAGE_CENTER,
	BANNER_POSITION.HOMEPAGE_SERVICE,
	BANNER_POSITION.LIST_CAR_FOR_SALE,
	BANNER_POSITION.LIST_CAR_FOR_RENT,
	BANNER_POSITION.LIST_CAR_PART,
	BANNER_POSITION.LIST_CAR_FOR_SALE_TOP,
	BANNER_POSITION.LIST_CAR_FOR_RENT_TOP,
	BANNER_POSITION.LIST_CAR_PART_TOP,
	BANNER_POSITION.LIST_CAR_CARE_TOP,
	BANNER_POSITION.LIST_CAR_CARE,
	BANNER_POSITION.CAR_REGISTRATION,
	BANNER_POSITION.SELL_YOUR_CAR,
	BANNER_POSITION.MENU_SERVICES,
	BANNER_POSITION.IMPORT_SUPERCAR,
	// BANNER_POSITION.IMPORT_SUPERCAR_DETAIL,
	BANNER_POSITION.VOUCHER_TOP,
	BANNER_POSITION.SUPPORT_SERVICES_TOP,
	BANNER_POSITION.CAR_LOAN_TOP,
];
export const BANNER_POSITIONS_WEBAPP = [
	BANNER_POSITION.HOMEPAGE_TOP,
	BANNER_POSITION.HOMEPAGE_CENTER,
	BANNER_POSITION.LIST_CAR_FOR_SALE,
	BANNER_POSITION.LIST_CAR_FOR_RENT,
	BANNER_POSITION.LIST_CAR_PART,
	BANNER_POSITION.CAR_FOR_RENT_DETAIL,
	BANNER_POSITION.CAR_FOR_SALE_DETAIL,
	BANNER_POSITION.CAR_PART_DETAIL,
	BANNER_POSITION.LIST_NEW_EVENT,
	BANNER_POSITION.LIST_SERVICE,
	BANNER_POSITION.CAR_STORE_DETAIL,
	BANNER_POSITION.LIST_CAR_CARE,
	BANNER_POSITION.CAR_CARE_DETAIL,
	BANNER_POSITION.CAR_CARE_STORE_DETAIL,
	BANNER_POSITION.IMPORT_SUPERCAR,
	BANNER_POSITION.IMPORT_SUPERCAR_DETAIL,
	BANNER_POSITION.FINANCIAL_SERVICE_TOP,
	BANNER_POSITION.CAR_LOAN_TOP,
];
export const VERTICAL_BANNER_POSITIONS_WEBAPP = [
	BANNER_POSITION.LIST_CAR_FOR_SALE,
	BANNER_POSITION.LIST_CAR_FOR_RENT,
	BANNER_POSITION.LIST_CAR_PART,
	BANNER_POSITION.CAR_STORE_DETAIL,
	BANNER_POSITION.LIST_COMMUNITY,
	BANNER_POSITION.COMMUNITY_DETAIL,
	BANNER_POSITION.LIST_NEW_EVENT,
	BANNER_POSITION.LIST_CAR_CARE,
	BANNER_POSITION.CAR_CARE_STORE_DETAIL,
];

export const RECOMMENDATION_IMAGE_SIZES: {
	[key: string]: {
		[key: string]: string;
	};
} = {
	APP_HORIZONTAL_BANNER_POSITIONS: {
		SIZE: "390*136",
		[POSITION.HOMEPAGE_SERVICE]: "358*100",
		[POSITION.HOMEPAGE_TOP]: "358*160",
		[POSITION.CAR_REGISTRATION]: "390*192",
		[POSITION.SELL_YOUR_CAR]: "390*192",
		[POSITION.MENU_SERVICES]: "358*160",
		[POSITION.CAR_LOAN_TOP]: "390*160",
	},
	WEP_APP_HORIZONTAL_DESKTOP: {
		[POSITION.LIST_CAR_FOR_SALE]: "1920*340",
		[POSITION.LIST_CAR_FOR_RENT]: "1920*340",
		[POSITION.CAR_STORE_DETAIL]: "1920*340",
		[POSITION.LIST_NEW_EVENT]: "1920*340",
		[POSITION.HOMEPAGE_CENTER]: "1920*340",
		[POSITION.HOMEPAGE_TOP]: "1920*340",
		[POSITION.CAR_FOR_SALE_DETAIL]: "1920*340",
		[POSITION.CAR_FOR_RENT_DETAIL]: "1920*340",
		[POSITION.CAR_PART_DETAIL]: "1920*340",
		[POSITION.LIST_SERVICE]: "1920*340",
		[POSITION.CAR_CARE_DETAIL]: "1920*340",
		[POSITION.CAR_CARE_STORE_DETAIL]: "1920*340",
		[POSITION.IMPORT_SUPERCAR]: "1920*504",
		[POSITION.IMPORT_SUPERCAR_DETAIL]: "1920*344",
		SIZE: "1074*240",
	},
	WEP_APP_HORIZONTAL_MOBILE: {
		[POSITION.IMPORT_SUPERCAR]: "768*378",
		[POSITION.IMPORT_SUPERCAR_DETAIL]: "768*236",
		SIZE: "390*120",
	},
	WEP_APP_VERTICAL: { SIZE: "342*434" },
};
